export const ACTIVE_USERS_TITLE = 'Active users';
export const ACTIVE_USERS_DESCRIPTION = 'Registered coaches and the athletes they actively manage';
